module.exports = __webpack_public_path__ + "static/media/Informationicon03@2x.c8c06a39.png";